export const DefaultCSPConfig = {
  cspConfiguration: {
    partner: 'pia',
    partnerTitle: 'PetSure Pet Insurance',
    auth0Config: {
      sit: {
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'pia-sit-petportal-auth.petsure.com.au',
        appClientId: '9rQZzxd4aWsZN8EgmNJ7VLnv3dOBA32O',
        cspMfaUrl: 'https://pia-sit-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-pia-sys.petsure.com.au/account-verification'
      },
      uat: {
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'pia-uat-petportal-auth.petsure.com.au',
        appClientId: 'biaJrhKSn2Vsw3RUqVC2u8qFmL2wfxQN',
        cspMfaUrl: 'https://pia-uat-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-pia-uat.petsure.com.au/account-verification'
      },
      preprod: {
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'pia-preprod-petportal-auth.petsure.com.au',
        appClientId: 'FY2oo64v7SHzUC6kEpr87lfgUv4lfdUd',
        cspMfaUrl: 'https://pia-preprod-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-pia-preprod.petsure.com.au/account-verification'
      },
      prod: {
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'pia-petportal-auth.petsure.com.au',
        appClientId: 'XXXX',
        cspMfaUrl: 'https://pia-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-petinsuranceaustralia.petsure.com.au/account-verification'
      }
    },
    liveVetConfig: {
      sit: {
        vetChatAppModule: 'petinsuranceaustralia.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      uat: {
        vetChatAppModule: 'petinsuranceaustralia.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      preprod: {
        vetChatAppModule: 'petinsuranceaustralia.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      prod: {
        vetChatAppModule: 'petinsuranceaustralia.vetchat.com.au',
        vetChatUrl: 'https://livevet.vetchat.com.au',
        vetChatConsultationUrl: 'https://livevet.vetchat.com.au/consult'
      }
    },
    bannerImage: {
      prod: 'https://www.petinsuranceaustralia.com.au/wp-content/uploads/2024/01/golden-retriever-mobile-1.jpg'
    },
    footerLogo: {
      prod: {
        imageUrl:
          'https://petcdnstore.blob.core.windows.net/csp-assets-petsure-preprod/images/footer/footer_bw_pia.png',
        imageTitle: 'Pet Insurance Australia',
        imageTitleDescription: 'Pet Insurance Australia'
      }
    },
    termsOfUseUrl:
      'https://petcdnstore.blob.core.windows.net/csp-common/pdfs/terms_of_use/Customer_Portal_Terms_of_Use_092024.pdf',
    cspCssFile: './styles/brands/pia/pia.css',
    header: {
      layoutConfig: {
        small: 'hamburger',
        large: 'horizontal'
      }
    },
    faqRedirection: {
      excessTooltip: {
        category: 'claims',
        question: 'How is my claim benefit calculated?'
      },
      editName: {
        category: 'policy management',
        question: `Why can't I edit my name in the Pet Portal?`
      }
    },
    isLiteModeEnabled: false,
    isLecBrand: false,
    gtm: {
      id: 'GTM-56PVBTDH',
      dataLayer: 'dataLayer'
    }
  }
};
